export default __webpack_public_path__ + "static/media/PRATIK MALHOTRA.aa3773b9.jpg";